export type unsafe_input = any;

type converted_type = Object | Array<any> | number | boolean | null | undefined | string;

/**
 * convert strings (from attributes) to data types
 * @param value a string to convert to a known type
 */
export const stringToType = (value: string): converted_type => {
  const firstLetter = _.first(value);
  const conversions = {
    undefined: undefined,
    false: false,
    true: true,
    null: null,
    NaN: NaN
  };

  let v;

  if (firstLetter === '{') {
    return JSON.parse(value);
  } else if (firstLetter === '[') {
    return JSON.parse(value);
  } else if ((v = +value) === v) {
    return v;
  }

  for (let key in conversions) {
    if (value === key) {
      return conversions[key];
    }
  }

  return value;
};



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/core/types.ts